<template>
  <div>
    <BaseImg :title="$t('contact.Title')" bgName="bg_contact.png"> </BaseImg>
    <PublicBreadcrumb />
    <div class="bottom">
      <div class="left">
        <h2 class="bigTitle">{{ $t('contact.TeamTitle') }}</h2>
        <div class="content">
          {{ $t('contact.Intro') }}
        </div>
        <div class="content margin13">
          {{ $t('contact.Direct') }}
        </div>
        <h3 class="goldTitle margin50">{{ $t('contact.Phone') }}</h3>
        <div class="content margin13"><a class="contact-link" href="tel:+6492801503">{{ $t('contact.LocalPhone') }}</a></div>
        <h3 class="goldTitle margin50">{{ $t('contact.Email') }}</h3>
        <div class="content margin13"><a class="contact-link" href="mailto:info@nzsky.co.nz">{{ $t('contact.General') }}</a></div>
        <h3 class="goldTitle margin50">{{ $t('contact.Address') }}</h3>
        <address class="content margin13">Level 2, 1 Broadway, Newmarket, Auckland, New Zealand</address>
        <p class="content margin13">{{ $t('contact.Visit') }}</p>
      </div>

      <ContactForm class="right"> </ContactForm>
    </div>
    <section class="contact-reminders">
      <div><h2>{{ $t('contact.DocumentsTitle') }}</h2><p>{{ $t('contact.Documents') }}</p><router-link :to="$siteLink('/kyc-source-of-funds')">{{ $t('contact.KycLink') }}</router-link></div>
      <div><h2>{{ $t('contact.PaymentTitle') }}</h2><p>{{ $t('contact.Payment') }}</p><router-link :to="$siteLink('/security')">{{ $t('contact.SafetyLink') }}</router-link></div>
      <router-link :to="$siteLink('/faq')">{{ $t('contact.FaqLink') }}</router-link>
      <router-link :to="{ path: $siteLink('/compliance').path, query: $siteLink('/compliance').query, hash: '#complaints' }">{{ $t('contact.ComplaintsLink') }}</router-link>
    </section>
  </div>
</template>

<script>
import BaseImg from '@/components/BaseImg.vue'
import PublicBreadcrumb from '@/components/PublicBreadcrumb.vue'
import ContactForm from '@/components/ContactForm.vue'

export default {
  components: {
    PublicBreadcrumb,
    BaseImg,
    ContactForm
  }
}
</script>

<style scoped>
address { font-style: normal; overflow-wrap: anywhere; }
.contact-reminders { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 28px 48px; max-width: 1240px; margin: 0 auto 64px; padding: 0 clamp(24px, 5vw, 40px); color: #163257; }
.contact-reminders h2 { margin: 0 0 14px; color: inherit; font-size: 24px; line-height: 1.4; }
.contact-reminders p { font-size: 17px; line-height: 1.8; }
.contact-reminders a { color: inherit; text-decoration: underline; text-underline-offset: 5px; min-height: 44px; display: inline-flex; align-items: center; }
.contact-link { color: inherit; text-decoration: underline; text-underline-offset: 3px; overflow-wrap: anywhere; }
.contact-link:focus-visible { outline: none; text-decoration-thickness: 3px; text-underline-offset: 6px; }
.bottom {
  min-width: 0;
  gap: 40px;
  width: 100%;
  max-width: 1440px;
  padding: 78px 100px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.left {
  width: 48%;
  min-width: 0;
  padding-top: 22px;
  box-sizing: border-box;
}
.goldTitle {
  font-size: 24px;
  font-weight: 600;
  color: #bc9a41;
  line-height: 33px;
  text-transform: uppercase;
}
.bigTitle {
  font-size: 48px;
  font-weight: 500;
  color: #163257;
  text-transform: uppercase;
}
.margin50 {
  margin-top: 50px;
}
.margin13 {
  margin-top: 13px;
}
.content {
  font-size: 18px;
  font-weight: 400;
  color: #163257;
  line-height: 1.7;
}
.right {
  width: 48%;
  min-width: 0;
}
@media only screen and (max-width: 768px) {
.contact-reminders { grid-template-columns: 1fr; margin-top: 24px; }
.bottom {
  min-width: 0;
  gap: 40px;
  width: 100%;
  padding: 5vw;
  display: block;
  justify-content: space-between;
  margin: 0 auto;
}
.left {
  width: 100%;
  padding-top: 2vw;
}
.goldTitle {
  font-size: 1.5rem;
  font-weight: 500;
  color: #bc9a41;
  line-height: 1.5rem;
  text-transform: uppercase;
}
.bigTitle {
  font-size: 1.5rem;
  font-weight: 500;
  color: #163257;
  line-height: 3.5rem;
  text-transform: uppercase;
}
.margin50 {
  margin-top: 3vw;
}
.margin13 {
  margin-top: 2vw;
}
.content {
  font-size: 1rem;
  font-weight: 400;
  color: #163257;
  line-height: 1.5rem;
}
.right {
  width: 100%;
  margin-top: 3vw;
}
}
</style>
